var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"a-h-100vh overflow-y-auto a-hide-scrollbar"},[(_vm.isAccountDataLoaded)?_c('transition',{attrs:{"name":_vm.globalTransitionName,"mode":"out-in"}},[_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }